import { render, staticRenderFns } from "./correct-popup.vue?vue&type=template&id=699a3949&scoped=true"
import script from "./correct-popup.vue?vue&type=script&lang=js"
export * from "./correct-popup.vue?vue&type=script&lang=js"
import style0 from "./correct-popup.vue?vue&type=style&index=0&id=699a3949&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699a3949",
  null
  
)

export default component.exports